/**
 * Surveyor Assignment module theme — aliases app brand (Patient indigo SoT).
 */
import { BRAND_THEME, BRAND_THEME_HEX } from "../../ui/brandTheme";

export const SURVEYOR_THEME = BRAND_THEME;
export const SURVEYOR_THEME_HEX = BRAND_THEME_HEX;

export const SURVEYOR_ROLE_CHIP =
  "bg-indigo-50 text-indigo-700 border border-indigo-100";

export const SURVEYOR_BTN = {
  row: `inline-flex items-center justify-center gap-1 h-6 px-2 text-[11px] font-medium rounded border transition-colors disabled:opacity-50 disabled:cursor-not-allowed ${BRAND_THEME.button.soft}`,
  primary: `inline-flex items-center justify-center gap-1.5 h-9 px-3 text-sm font-semibold rounded-md transition-colors disabled:opacity-50 disabled:cursor-not-allowed ${BRAND_THEME.button.primary}`,
  outline: `inline-flex items-center justify-center gap-1.5 h-9 px-3 text-sm font-medium rounded-md border transition-colors disabled:opacity-50 disabled:cursor-not-allowed ${BRAND_THEME.button.outline}`,
  clear: `inline-flex items-center justify-center gap-1 h-8 px-2.5 text-xs font-medium text-indigo-700 hover:bg-indigo-50 rounded-md border border-indigo-200 transition-colors whitespace-nowrap`,
  modalPrimary: `inline-flex items-center justify-center gap-1.5 h-9 px-3 text-sm font-semibold rounded-md transition-colors disabled:opacity-50 disabled:cursor-not-allowed ${BRAND_THEME.button.primary}`,
  modalCancel:
    "inline-flex items-center justify-center gap-1.5 h-9 px-3 text-sm font-medium rounded-md border border-slate-300 bg-white text-slate-700 hover:bg-slate-50 disabled:opacity-50 disabled:cursor-not-allowed",
  modalClose:
    "inline-flex h-7 w-7 items-center justify-center rounded-md text-slate-500 hover:bg-indigo-50 hover:text-indigo-700 transition-colors shrink-0",
};

export const SURVEYOR_FIELD = {
  search: `w-full h-8 pl-9 pr-8 text-sm bg-white border border-indigo-200 rounded-md text-slate-800 placeholder:text-slate-400 outline-none transition-colors ${BRAND_THEME.fieldFocus}`,
  select: `appearance-none h-8 min-w-[130px] pl-3 pr-8 text-sm rounded-md border border-indigo-200 text-slate-700 bg-white outline-none cursor-pointer transition-colors ${BRAND_THEME.fieldFocus}`,
  selectActive: "border-indigo-400 text-indigo-700 font-medium bg-indigo-50/60",
};

export const SURVEYOR_MODAL = {
  backdrop: "fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/40",
  panel: "w-full max-w-lg rounded-xl border border-indigo-200 bg-white shadow-xl flex flex-col overflow-hidden max-h-[90vh]",
  head: `flex items-center justify-between gap-3 px-4 py-3 border-b shrink-0 ${BRAND_THEME.modalHead}`,
  title: `text-sm font-semibold uppercase tracking-wide ${BRAND_THEME.modalTitle}`,
  subtitle: "mt-0.5 text-[11px] text-slate-600 normal-case tracking-normal font-normal",
  body: "p-4 overflow-y-auto flex-1",
  footer:
    "flex items-center justify-end gap-2 px-4 py-3 border-t border-indigo-100 bg-indigo-50/40 shrink-0",
};

